<template>
  <div id="app">
    <AppLoading v-if="loading" />
    <div v-else>
      <NavBar />
      <TopElement />
      <FlowerList class="mt-32 mb-40" />
      <ShopList class="mb-40" />
      <BottomElement />
      <CartBasket />
    </div>
  </div>
</template>

<script>
import FlowerList from "./components/FlowerList.vue";
import NavBar from "./components/NavBar.vue";
import TopElement from './components/TopElement.vue';
import ShopList from "./components/ShopList.vue";
import BottomElement from "./components/BottomElement.vue";
import AppLoading from "./components/AppLoading.vue";
import CartBasket from "./components/CartBasket.vue";

export default {
  components: {
    FlowerList,
    NavBar,
    TopElement,
    ShopList,
    BottomElement,
    AppLoading,
    CartBasket,
  },
  data() {
    return {
        loading: true, 
    };
  },
  mounted() {
    const img = new Image();
    img.src = require('./assets/images/top.jpg'); // Adjust the path if needed

    // Load the font using FontFace API
    const font = new FontFace('Lexend', `url(${require('./assets/fonts/lexend-latin-400-normal.woff2')})`);

    Promise.all([
        new Promise((resolve) => {
            img.onload = resolve; // Resolve when the image is loaded
        }),
        font.load().then((loadedFont) => {
            document.fonts.add(loadedFont); // Add the font to the document
        })
    ]).then(() => {
        this.loading = false; // Set loading to false once both image and font are loaded
    });
  },
};
</script>

<style lang="scss">
// @import "../node_modules/@fontsource/lexend/400.css";
body {
  font-family: "Lexend";
}

@font-face {
  font-family: 'Lexend';
  src: url('@/assets/fonts/lexend-latin-400-normal.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
}
</style>
